<template>
    <div class="flex flex-wrap border-b border-gray-400 mt-4 pb-1 mb-2 md:mb-0">
        <div class="w-full sm:w-3/4">
            <div class="relative mt-2">
                <label class="leading-none self-center text-black mr-2" for="cheatSheetMarket">Market:</label>
                <select class="form-control form-control-sm form-control-fixed bg-white mb-1" v-model="market" id="cheatSheetMarket" aria-label="Select Market">
                    <template v-for="option in markets">
                        <option :class="{ 'bg-yellow-200': option.highlight }" :value="option.value">
                            {{ option.label }}
                        </option>
                    </template>
                </select>
            </div>
        </div>
        <dt-flip-charts-button class="ml-auto xs:mt-3 print:hidden"></dt-flip-charts-button>
    </div>

    <dt-commodity-navigation v-if="market === 'futures'" class="print:hidden"></dt-commodity-navigation>

    <div class="border-t-2 border-blue-600 mt-2">
        <div class="table-header flex flex-wrap ">
            <div class="w-full sm:w-3/4">
                <div class="relative">
                    <label class="leading-none self-center text-black mr-2" for="cheatSheetPeriod">Period:</label>
                    <select class="form-control form-control-sm form-control-fixed bg-white mb-1" v-model="period" id="cheatSheetPeriod" aria-label="Select Period">
                        <template v-for="option in periods">
                            <option :class="{ 'bg-yellow-200': option.highlight }" :value="option.value">
                                {{ option.label }}
                            </option>
                        </template>
                    </select>
                </div>
            </div>
            <dt-show-triggered-markets class="ml-auto xs:mt-3"></dt-show-triggered-markets>
        </div>
    </div>

    <data-table v-if="loadTable" :default-request="request" :default-columns="columns"></data-table>
</template>

<script setup>
import { ref, computed, onMounted, watch } from 'vue';
import { useLocationHash } from '../../mixins/LocationHash';

const props = defineProps({
    type: {
        type: String,
        required: true
    },
    defaultColumns: {
        type: Object,
        required: true
    }
});

const { addToHash, searchHash } = useLocationHash();

const markets = ref([
    { label: 'Futures', value: 'futures'},
    { label: 'Forex', value: 'forex' }
]);

const periods = ref([
    { label: 'Intraday', value: 'intraday'},
    { label: 'End-of-Day', value: 'eod', default: false }
]);

const market = ref(searchHash('market')?.value || 'futures');
const period = ref(searchHash('period')?.value || 'intraday');
const loadTable = ref(false);

const request = computed(() => {
    return {
        market: market.value,
        period: period.value,
        type: props.type,
        groupBy: groupBy.value,
        route: window.route('api.cheat-sheet')
    };
});

const groupBy = computed(() => {
    if (market.value === 'futures') {
        return ['uscCategory', 'symbolName'];
    }
});

const columns = computed(() => {
    if (market.value === 'futures') {
        if (period.value === 'eod') {
            return props.defaultColumns.futures.eod;
        } else {
            return props.defaultColumns.futures.intraday;
        }
    } else if (market.value === 'forex') {
        if (period.value === 'eod') {
            return props.defaultColumns.forex.eod;
        } else {
            return props.defaultColumns.forex.intraday;
        }
    }
});

watch(market, () => {
    addToHash('market', market.value);
});

watch(period, () => {
    addToHash('period', period.value);
});

onMounted(() => {
    loadTable.value = true;
});
</script>
